import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface PaylandProcessorDetailsPageProps {
    processor: ProcessorDetails
}

const PaylandConfigurationCard = ({ processor }: PaylandProcessorDetailsPageProps) => {
    const options = processor.options as Record<string, any> | null

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>Payland Configuration</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">API Key</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Secret Key</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Payment Type</p>
                        <Badge variant="secondary">3D Secure</Badge>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Crypto Support</p>
                        <Badge variant="secondary">Enabled (apm_payland_crypto)</Badge>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Environment</p>
                        <Badge variant={options?.testMode ? 'outline' : 'default'}>
                            {options?.testMode ? 'Staging' : 'Production'}
                        </Badge>
                    </div>
                    {options?.callbackUrl && (
                        <div>
                            <p className="text-sm text-muted-foreground">Callback URL</p>
                            <p className="font-mono text-sm truncate">{options.callbackUrl}</p>
                        </div>
                    )}
                    {options?.successUrl && (
                        <div>
                            <p className="text-sm text-muted-foreground">Success URL</p>
                            <p className="font-mono text-sm truncate">{options.successUrl}</p>
                        </div>
                    )}
                    {options?.failureUrl && (
                        <div>
                            <p className="text-sm text-muted-foreground">Failure URL</p>
                            <p className="font-mono text-sm truncate">{options.failureUrl}</p>
                        </div>
                    )}
                </div>
            </CardContent>
        </Card>
    )
}

export const PaylandProcessorDetailsPage = ({ processor }: PaylandProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader type="payland" processor={processor} />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <PaylandConfigurationCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
        </>
    )
}
